export const ImageSizes = Object.freeze({
  THUMBNAIL: 'pr:thumbnail',
  SMALL: 'pr:small',
  MEDIUM: 'pr:medium',
  LARGE: 'pr:large',
  BANNER: 'pr:banner',
  FULL: 'pr:full'
});
